import { render, staticRenderFns } from "./kstable.vue?vue&type=template&id=5a2e8e70&scoped=true&"
import script from "./kstable.vue?vue&type=script&lang=js&"
export * from "./kstable.vue?vue&type=script&lang=js&"
import style0 from "./kstable.vue?vue&type=style&index=0&id=5a2e8e70&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e8e70",
  null
  
)

export default component.exports